import { useState } from 'react';
import {
    Flex,
    FormControl,
    FormErrorMessage,
    FormHelperText,
    FormLabel,
    Textarea,
} from '@chakra-ui/react';
import { useController, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { type HtmlFormInput } from '../../hooks/useHtmlFormInputs';

export function DescriptionField({ input }: { input: HtmlFormInput<string> }) {
    const { control } = useFormContext();
    const { t } = useTranslation();
    const {
        field: { onChange, value, ...fieldProps },
        fieldState: { error },
    } = useController({
        name: 'description',
        control,
        rules: {
            required: t('common.errors.required'),
            maxLength: 2048,
        },
    });
    const [description, setDescription] = useState(value);

    return (
        <FormControl variant="fastDetails" isInvalid={error !== undefined}>
            <FormLabel>{t('fast.provide_details.description.label')}</FormLabel>
            <FormHelperText>{t('fast.provide_details.description.helper_text')}</FormHelperText>
            <Textarea
                {...fieldProps}
                minHeight="22.2rem"
                padding="2rem"
                fontSize="2rem"
                value={value}
                onChange={(e) => {
                    onChange(e);
                    setDescription(e.target.value);
                    input.onChange(e.target.value);
                }}
            />
            <Flex justifyContent="flex-end" fontSize="xs" color="general.greyCounter">
                {description.length}/2048
            </Flex>
            <FormErrorMessage mt={-1}>{error?.message}</FormErrorMessage>
        </FormControl>
    );
}
